import { Button } from "@/components/Core/Button";
import { formatDate } from "@/helper/HelperFunction";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./ViewWarehouseModal.module.css";
import ViewField from "@/components/ViewField";

export default function ViewWarehouseModal({ show, setShow, data }) {
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      header="Details"
      showCloseIcon={true}
      width="550px"
      footer={
        <div className={classes.footer}>
          <Button
            label="Cancel"
            variant="tertiary"
            onClick={() => setShow(false)}
          />
        </div>
      }
    >
      <div className={classes.mainWrapper}>
        <div className={classes.fullGrid}>
          <ViewField label="Warehouse Name" value={data?.name} />
        </div>
        <ViewField label="Location No" value={data?.locationNo} />
        <ViewField label="Country" value={data?.country} />
        <ViewField label="City" value={data?.city} />
        <ViewField label="Zip" value={data?.zip} />
        <ViewField label="Phone" value={data?.addrPhone} />
        <ViewField label="Created At" value={formatDate(data?.createdAt)} />
        <div className={classes.fullGrid}>
          <ViewField label="Address" value={data?.address1} />
        </div>
      </div>
    </ModalSkeleton>
  );
}
